import type { UseQueryInteropSupportedHookOptions } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop';

import type {
	useDraftsDataHomeDraftsQuery$data,
	useDraftsDataHomeDraftsQuery$variables,
} from './__generated__/useDraftsDataHomeDraftsQuery.graphql';

const PAGE_SIZE = 24;

export const DRAFTS_QUERY_OPTIONS: UseQueryInteropSupportedHookOptions<
	useDraftsDataHomeDraftsQuery$data,
	useDraftsDataHomeDraftsQuery$variables
> = {
	variables: {
		cqlcontext: `{"contentStatuses":["draft"]}`,
		first: PAGE_SIZE,
	},
};
